import { render, staticRenderFns } from "./addInpt.vue?vue&type=template&id=7855ad48"
import script from "./addInpt.vue?vue&type=script&lang=js"
export * from "./addInpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports